import { FileUploader } from 'ng2-file-upload';

import { LoopBackConfig } from '../../sdk/lb.config'
import { PayeeApi, StorageApi } from '../../sdk/services';
import { GlobalEventsManager } from '../../../events-manager.component'

export abstract class FileUpload {
  id = this.userApi.getCurrentId();
  docsValid?: boolean;
  uploader?: FileUploader;

  constructor(
    protected userApi: PayeeApi,
    protected storageApi: StorageApi,
    public eventsManager: GlobalEventsManager
  ) {
  }

  abstract validateDocs(): void;

  getFileUrl(fileName: string) {
    return LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+ this.id +"/download/" + fileName + "?access_token=" + this.userApi.getCurrentToken().id;
  }

  setUpFileUploader(docType: string, submissionId?: number, payeeId?: number, submissionType?: string) {
    // console.log("setUpFileUploader: submissionId");
    console.log(docType, submissionId, payeeId, submissionType);
    if (submissionType === 'Customer') {
      this.uploader = new FileUploader({url: LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+payeeId+"/upload?payeeId="+payeeId+"&submissionId="+submissionId+"&docType="+docType});
    } else if (submissionId) {
      this.uploader = new FileUploader({url: LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+ this.id +"/upload?submissionId="+submissionId+"&docType="+docType});
    } else {
      this.uploader = new FileUploader({url: LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+ this.id +"/upload?docType="+docType});
    }
    this.uploader.authToken = this.userApi.getCurrentToken().id;
    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      // console.log("ori url");
      // console.log(item.url);
      let url = item.url.split('=');


      // console.log("url");
      // console.log(url);
      // console.log("response");
      // console.log(response);
      if (status !== 500) {
        this.updateDocStatus(url[url.length - 1], JSON.parse(response).result.files.file[0].name);
        this.validateDocs();
      } else {  // TODO: On error

      }
    };
  }

  upload(file: any, name: any, submissionId?: number) {
    this.uploader.addToQueue([file]);

    // console.log("this.uploader.options");
    // console.log(this.uploader.options);
    if (submissionId) {
      this.uploader.setOptions({url: LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+ this.id +"/upload?submissionId="+submissionId+"&docType="+name});
    } else {
      this.uploader.setOptions({url: LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/"+ this.id +"/upload?docType="+name});
    }

    // console.log("after set this.uploader.options");
    // console.log(this.uploader.options);

    this.uploader.authToken = this.userApi.getCurrentToken().id;

    this.uploader.uploadAll();
    // this.uploader.uploadItem(file);
    // this.uploader.clearQueue()
  }

  addDoc(name: string, event, zip?: boolean, submissionId?: number, payeeId?: number, submissionType?: string) {
    console.log('file-upload: addDoc: name');
    console.log({name});
    console.log({submissionId});
    console.log(name, event, zip, submissionId, payeeId, submissionType);

    let file = event.target.files[0];
    let fileName = file.name.split('.');
    let ext = fileName[fileName.length - 1];

    // Check file size <= 10MB, file type either pdf of doc
    if (file.size > 10000000) {
      this.eventsManager.showPopUp('File size limit is 10MB. Please upload a smaller file.');
      return;
    }
    if (this.uploader == null) {
      if (submissionId) {
        this.setUpFileUploader(name, submissionId, payeeId, submissionType);
      } else {
        this.setUpFileUploader(name);
      }
    }

    this.storageApi.getContainer(this.id.toString()).subscribe(
      res => {
        // Container exists
        this.upload(file, name, submissionId);
      },
      err => {
        // Container doesn't exist
        this.storageApi.createContainer({'name': this.id.toString()}).subscribe(
          res => {
            this.upload(file, name, submissionId);
          },
          err => console.log(err)
        )
      }
    );
  }

  download(name: string) {
    this.storageApi.getFile(this.id, name).subscribe(
      res => {
        console.log(res);
        window.open(LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.userApi.getCurrentId() + "/download/" + name)
      },
      err => console.log(err)
    );
  }

  getFileDetails(type: string) {
    let filter = {
      where: {
        'type': type,
        'is_deleted': null
      },
      order: 'id DESC',
      limit: 1
    }

    return this.userApi.getAttachments(this.id, filter);
  }

  deleteDoc(name: string) : any {
    this.userApi.deleteAttachment(this.id, name).subscribe(
      res => {
        console.log(res);
        return false;
      },
      err => console.log(err)
    )
  }

  abstract updateDocStatus(name: string, fileName?: string) : void;

}
